import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .question {
    color: ${({ theme }) => theme.colors.davysGrey};
    font-size: 12px;
    max-width: 320px;
  }

  .toggle {
    display: grid;
    grid-template-columns: auto auto auto;
    grid-gap: 8px;
    align-items: center;

    span {
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.cflowerBlue};
    }
  }
`;
